import { render } from "./LinkWrapper.vue?vue&type=template&id=891c065e"
import script from "./LinkWrapper.vue?vue&type=script&lang=js"
export * from "./LinkWrapper.vue?vue&type=script&lang=js"

import "./LinkWrapper.vue?vue&type=style&index=0&id=891c065e&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__